/*
 * scrollLock — body scroll capture/release for modals and nav overlays.
 *
 * Re-entrant: nested capture/release pairs are safe (e.g. a modal opening
 * over the nav overlay). Body styles are only touched on the outermost
 * pair — the first `capture()` fixes the body at the current scroll offset
 * (prevents the page jumping to top on iOS) and the final `release()`
 * restores styles and scroll position. `release()` with no outstanding
 * capture is a no-op. Pair every capture with a release.
 */
let windowTop = 0;
let depth = 0;

export function capture() {
	depth += 1;
	if (depth > 1) return;
	windowTop = window.scrollY;
	document.body.style.position = 'fixed';
	document.body.style.top = `${windowTop * -1}px`;
	document.body.style.overflow = 'hidden';
	document.body.style.width = '100vw';
}

export function release() {
	if (depth === 0) return;
	depth -= 1;
	if (depth > 0) return;
	document.body.style.position = '';
	document.body.style.top = '';
	document.body.style.overflow = '';
	document.body.style.width = '';
	window.scroll(0, windowTop);
}
